import { useUserStatusContext } from '../../../context/UserStatus';

// The org useRequest puts in the query string; POST bodies must carry the same one.
const useCareScope = () => {
    const { userStatus, activeOrgId } = useUserStatusContext();

    return activeOrgId ?? userStatus?.hero_organization_id;
};

export default useCareScope;
